import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';

import {setIsModalOpen} from '../../../actions/AccessGroups/SetIsModalOpen';
import {clearErrors} from '../../../actions/erroractions';

import LoadingWrapper from '../LoadingWrapper';
import Notifications from '../../Common/Notifications';
import StyledCCSModal from './StyledCCSModal';

const sizes = ['x-small', 'small', 'medium', 'large', 'takeover'];

const Modal = ({
	isLoading = null,
	children,
	modalsize = 'medium',
	modalOnModal = false,
	onCloseDontClearErrors = false,
	...rest
}) => {
	const dispatch = useDispatch();

	const handleIsModalOpen = (val) => dispatch(setIsModalOpen(val));
	const handleClearErrors = (val) => dispatch(clearErrors(val));
	const handleModalErrors = (val) => handleClearErrors(val).then(() => handleIsModalOpen(val));

	useEffect(() => {
		if (rest.show) handleModalErrors(rest.show);
		return () => {
			if (modalOnModal) handleClearErrors(false);
			else if (onCloseDontClearErrors) handleIsModalOpen(false);
			else handleModalErrors(false);
		};
	}, [rest.show]);

	const props = {};
	if (isLoading !== null) props.isLoading = isLoading;
	if (modalsize === 'small' || modalsize === 'x-small') props.spacing = 'sm';
	return (
		<StyledCCSModal modalsize={modalsize} {...rest}>
			<Notifications isModal />
			<LoadingWrapper {...props}>{children}</LoadingWrapper>
		</StyledCCSModal>
	);
};

Modal.propTypes = {
	isLoading: PropTypes.bool,
	loadingSpacingSmall: PropTypes.bool,
	modalsize: PropTypes.oneOf(sizes),
	modalOnModal: PropTypes.bool, // for error handling to clear errors but keep isModalOpen in true
	onCloseDontClearErrors: PropTypes.bool // for error handling to show errors in the underlying page
};

export default Modal;
